import { CheckCircleOutlined, ClockCircleOutlined } from "@ant-design/icons";

import { SecondaryText } from "@/components/Typography/Styled";

import { StyledTeamHeader } from "../../Styled";
import { LastUpdated } from "../../types";

interface TeamHeaderProps {
    lastUpdated: LastUpdated;
}

export const TeamHeader = ({ lastUpdated }: TeamHeaderProps) => {
    if (!lastUpdated?.team && !lastUpdated?.activeSchedule) {
        return null;
    }

    return (
        <StyledTeamHeader>
            {lastUpdated?.team && (
                <SecondaryText>
                    <ClockCircleOutlined />
                    Команда: {lastUpdated.team}
                </SecondaryText>
            )}

            {lastUpdated?.activeSchedule && (
                <SecondaryText>
                    <CheckCircleOutlined />
                    Маршрут: {lastUpdated.activeSchedule}
                </SecondaryText>
            )}
        </StyledTeamHeader>
    );
};
